import Cookies from "js-cookie";

export function getToken() {
  let token = '';
  if (process.env.VUE_APP_ENV !== 'development') {
    token = Cookies.get('token', { domain: '.591ylc.com' });
  } else {
    token = Cookies.get('token');
  }
  return token;
}

export function setToken(token) {
  if (process.env.VUE_APP_ENV !== 'development') {
    Cookies.set('token', token, { expires: 1, domain:'.591ylc.com' });
  } else {
    Cookies.set('token', token, { expires: 1 });
  }
}

export function removeToken() {
  if (process.env.VUE_APP_ENV !== 'development') {
    Cookies.remove('token', { domain: '.591ylc.com' });
  } else {
    Cookies.remove('token');
  }
}
